import { BraveWallet } from '@react-web3-wallet/brave-wallet';
import { DeFiWallet } from '@react-web3-wallet/defiwallet';
import { MetaMask } from '@react-web3-wallet/metamask';
import { createCurrentWallet, createWallet } from '@react-web3-wallet/react';
import { getConfigByName } from './walletConfigs';
export const metaMask = createWallet(getConfigByName(MetaMask.walletName).connector);
export const defiWallet = createWallet(getConfigByName(DeFiWallet.walletName).connector);
export const braveWallet = createWallet(getConfigByName(BraveWallet.walletName).connector);
const walletMap = {
    [MetaMask.walletName]: metaMask,
    [DeFiWallet.walletName]: defiWallet,
    [BraveWallet.walletName]: braveWallet,
};
export const getWallet = (walletName) => {
    const wallet = walletMap[walletName];
    if (wallet)
        return wallet;
    throw new Error(`unknown wallet ${walletName}`);
};
export const currentWallet = createCurrentWallet([
    metaMask,
    defiWallet,
    braveWallet,
]);
